import React from "react";

/** One stat tile in the top row ("Best Single Week", etc.). */
const CupFactTile = ({ fact }) => (
    <div className="relative rounded-2xl border border-border bg-surface px-[18px] py-4 shadow-card">
        <div
            className={`absolute bottom-3 left-0 top-3 w-1 rounded-r ${fact.accent}`}
        />
        <div className="font-sans text-[25px] font-extrabold leading-tight text-forest tabular-nums">
            {fact.value}
        </div>
        <div className="mt-1 text-[9.5px] font-sans font-extrabold uppercase tracking-[0.14em] text-text-muted">
            {fact.label}
        </div>
        <div className="mt-1.5 text-[11.5px] font-sans font-bold text-text-mid">
            {fact.who}
        </div>
    </div>
);

export default CupFactTile;
